export default [{
  id: 0,
  messages: [
    { msg: 'option1', trigger: 1 },
    { msg: 'option2', trigger: 2 },
    { msg: 'option3', trigger: 3 }],
},
{
  id: 1,
  end: true,
  messages: ['end'],
},
{
  id: 2,
  messages: [
    { msg: 'option42', trigger: 4 },
    { msg: 'option52', trigger: 5 },
    { msg: 'option62', trigger: 6 }],
},
{
  id: 3,
  messages: [
    { msg: 'option43', trigger: 4 },
    { msg: 'option53', trigger: 5 },
    { msg: 'option63', trigger: 6 }],
},
];
